/**
 * ui model类型
 */
export enum UIModelType {
    PRESENTATION= 'Presentation',
    // 页面内
    SLIDE= 'Slide',
    MASTER= 'Master',
    LAYOUT= 'Layout',

    // 元素
    SHAPE= 'Shape', // 图形和文本框
    IMAGE= 'Image', // 图片
    TABLE= 'Table', // 表格
    GROUP= 'Group', // 组合
    CONNECTOR= 'Connector', // 连接线
    CHART= 'Chart', // 图表
    NOTE= 'Note',   // 备注
    SMART_ART= 'SmartArt',   // SmartArt

    // 单独
    TIMING = 'Timing',
    ANIMATION= 'Animation',

    // 其他ui元素类型
    EMPTY= 'Empty', // 未选中时候的空model
    MULTIPLY= 'Multiply', // 多选元素聚合元素
    GAP='Gap', // 页面间隔

    // 图表子表类型
    BAR = 'bar',
    BAR_3D = 'bar3d',
    LINE = 'line',
    LINE_3D = 'line3d',
    PIE = 'pie',
    PIE_3D  = 'pie3d',
    RADAR = 'radar',
    // 圆环图
    DOUGHNUT = 'doughnut',
    // 散点图
    SCATTER = 'scatter',
    // 面积图
    AREA = 'area',
    AREA_3D = 'area3d',
    // 气泡图
    BUBBLE = 'bubble',
    // 股价图
    STOCK = 'stock',
    // 子母图
    OF_PIE = 'ofpie',

    // 节
    SECTION = 'section',

    // 参考线
    GUIDES = 'guides',

    // 主题
    THEME = 'theme',
}

// 形状图片填充-充满
export const SHAPE_IMAGE_FILL = 'shape-image-fill';
// 形状图片填充-平铺
export const SHAPE_IMAGE_TILE_FILL = 'shape-image-tile-fill';

export const SourceType = {
    MASTER: 'master',
    LAYOUT: 'layout',
    SLIDE: 'slide',
};
export type SourceType = typeof SourceType[keyof typeof SourceType];
